import { ObservableResult } from '../../models/result.model';
import { ResourcesDataService } from './resources-data.service';
import {
  ResourceSalutation,
  ResourceCountry,
  ResourceLanguage,
  ResourceProvinces,
  ResourceCurrencies,
  ResourceIsoLanguage
} from '../../models/resources/resources.model';
import mockTranslation from '../../assets/json/mock-translation.json';

export class MockResourcesDataService implements ResourcesDataService {

  readonly resourceCountries = [
    {
      Id: 0,
      Name: 'string',
      IsoCode: 'string',
      PhonePrefix: 'string',
      IsPriority: true
    }
  ];

  readonly resourceLanguages = [
    {
      Id: 0,
      Name: 'string',
      IsoCode: 'string',
    }
  ];

  readonly resourceIsoLanguages: ResourceIsoLanguage[] = [
    {
      Code: 'aa',
      Name: 'Afar',
      NativeName: 'Afar',
      IsoLanguageCode: 'aar',
      Inactive: false,
    },
    {
      Code: 'de',
      Name: 'German',
      NativeName: 'Deutsch',
      IsoLanguageCode: 'deu',
      Inactive: false,
    },
    {
      Code: 'de-CH',
      Name: 'German (Switzerland)',
      NativeName: 'Deutsch (Schweiz)',
      IsoLanguageCode: 'deu',
      Inactive: false,
    },
    {
      Code: 'en',
      Name: 'English',
      NativeName: 'English',
      IsoLanguageCode: 'eng',
      Inactive: false,
    },
    {
      Code: 'fr',
      Name: 'French',
      NativeName: 'Français',
      IsoLanguageCode: 'fra',
      Inactive: false,
    },
    {
      Code: 'it',
      Name: 'Italian',
      NativeName: 'Italiano',
      IsoLanguageCode: 'ita',
      Inactive: false,
    },
    {
      Code: 'cs',
      Name: 'Czech',
      NativeName: 'Čeština',
      IsoLanguageCode: 'ces',
      Inactive: true,
    }
  ];

  readonly resourceCurrencies = [
    {
      Id: "GBP",
      IsoCode: "GBP",
      Description: "Britisches Pfund",
      RatioToEuro: 0.8712,
      Inactive: false,
    },
  ];

  readonly resourceSalutation = [
    {
      Id: 0,
      Inactive: false,
      SortOrder: 0,
      Description: "string"
    },
  ];

  readonly resourceProvinces = [
    {
      Code: 'string',
      Text: 'string',
      CountryCode: 'string',
    }
  ];


  getResourceCountries(): ObservableResult<ResourceCountry[]> {
    return ObservableResult.ofSuccess(this.resourceCountries);
  }

  getResourceLanguages(): ObservableResult<ResourceLanguage[]> {
    return ObservableResult.ofSuccess(this.resourceLanguages);
  }

  getResourceIsoLanguages(): ObservableResult<ResourceIsoLanguage[]> {
    return ObservableResult.ofSuccess(this.resourceIsoLanguages);
  }

  getResourceCurrencies(): ObservableResult<ResourceCurrencies[]> {
    return ObservableResult.ofSuccess(this.resourceCurrencies);
  }

  getResourceSalutation(): ObservableResult<ResourceSalutation[]> {
    return ObservableResult.ofSuccess(this.resourceSalutation);
  }

  getResourceProvinces(): ObservableResult<ResourceProvinces[]> {
    return ObservableResult.ofSuccess(this.resourceProvinces);
  }

  getResourcesTranslations(domain: string): ObservableResult<any> {

    return ObservableResult.ofSuccess(mockTranslation);
  }

  getResourcesTranslationsByLanguageCode(domain: string, languageCode: string):ObservableResult<any>  {

    return ObservableResult.ofSuccess(mockTranslation);
  }
}
